var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.isLoading)?_c('div',{staticClass:"loading-overlay"},[_c('div',{staticClass:"loading-content"},[_c('span',{staticClass:"loading-icon"}),_c('p',[_vm._v("生成中")])])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }